import axios from "axios";

const httpClient = axios.create();

httpClient.interceptors.response.use(
  (response) => response,
  (error) =>
    Promise.reject(
      (error.response && error.response.data) || "Something went wrong!"
    )
);

export default httpClient;
